import "./MediaInfo.scss";
import { define } from "@shared/Lib/registry";
import type { Component } from "@shared/Lib/types";

export class MediaInfo implements Component {
  readonly el: HTMLElement;

  constructor(el: HTMLElement) {
    this.el = el;
    this.init();
  }

  private init(): void {}

  destroy(): void {}
}

define("MediaInfo", (el) => new MediaInfo(el));
